export default {
  type: 'text',
  title: `Paragraph`,
  icon: `align-left`,
  template: (config) => `
      <p
        contenteditablebind
        contenteditable="true"
        feature-obj="feature"
        org-index="orgIndex"
        data-index="${config.index}"
        id="add-paragraph"
        ng-model="feature.content"
        data-xplaceholder="Type your text here"
        ng-attr-data-placeholder="{{(!feature.content.trim().length && 'Type your text here') || '' }}"
        ng-bind-html="feature.content">
      </p>
    `,
  onPaste: function (elem) {
    return {
      type: 'text',
      content: elem.html(),
    }
  },
  initialInflation: function () {
    return {
      type: 'text',
      content: '',
    }
  },
  beforeSave: function (ansObj) {
    ansObj.content = ansObj.content || '<br />'
    return true
  },
  convertable: true,
}
